import { render, staticRenderFns } from "./DeleteAppUserBindingOwner.vue?vue&type=template&id=efde2d86"
import script from "./DeleteAppUserBindingOwner.vue?vue&type=script&lang=js"
export * from "./DeleteAppUserBindingOwner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports